// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2MAyb","obliqueLineWrap":"membershipbadge_obliqueLineWrap__R9SBO","obliqueLine":"membershipbadge_obliqueLine__1kCvL"};